import { CarServiceListComponent } from './Modules/car-service-list/car-service-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { paths } from './Shared/enums/paths.enum';
import { MobileVerificationComponent } from './Modules/mobile-verification/mobile-verification.component';
import { OtpVerificationComponent } from './Modules/otp-verification/otp-verification.component';
import { CarListComponent } from './Modules/car-list/car-list.component';
import { CarServiceComponent } from './Modules/car-service/car-service.component';
import { ConfirmBookingComponent } from './Modules/confirm-booking/confirm-booking.component';
import { BookingSummaryComponent } from './Modules/booking-summary/booking-summary.component';
import { PathResolverService } from './Shared/services/configuration_service/path-resolver-service.service';
import { PageNotFoundComponent } from './Shared/common_components/page-not-found/page-not-found.component';
import { AuthGuard } from './Shared/authGaurd/auth.guard';
import { LanguageComponent } from './Shared/common_components/language/language.component';
import { DealerSelectionComponent } from './Modules/dealer-selection/dealer-selection.component';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';

const childroutes: Routes = [
  { path: '', redirectTo: paths.BOOKAPPOINTMENT, pathMatch: 'full' },
  { path: paths.BOOKAPPOINTMENT, component: MobileVerificationComponent  },
  { path: paths.OTPVERIFICATION, component: OtpVerificationComponent,canActivate: [AuthGuard]  },
  { path: paths.CARLIST, component: CarListComponent,canActivate: [AuthGuard]  },
  { path: paths.CARSERVICE, component: CarServiceComponent,canActivate: [AuthGuard]  },
  { path: paths.CONFIRMBOOKING, component: ConfirmBookingComponent,canActivate: [AuthGuard]  },
  { path: paths.BOOKINGSUMMARY, component: BookingSummaryComponent,canActivate: [AuthGuard]  },
  { path: paths.DEALERSELECTION, component: DealerSelectionComponent  },
  { path: paths.CARSERVICELIST, component: CarServiceListComponent  },
  { path: paths.PRIVACYPOLICY, component: PrivacyPolicyComponent  },

];

const routes: Routes = [
  { path: '', redirectTo: 'no', pathMatch: 'full' },
  {
    path: ':lang',
    component: LanguageComponent,
    children: childroutes
  },
  {
    path: '**',
    resolve: { path: PathResolverService },
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
